import React from 'react';
import PropTypes from 'prop-types';

import {
  RatingWrapper,
  StarWrapper,
  SkeletonStar,
  FilledStar,
  FilledStarWrapper,
  ListingRatingContainer,
} from './ListingRating.style';

import starSvg from '../../static/images/icons/RatingStar.svg';
import starEmptySvg from '../../static/images/icons/RatingStarEmpty.svg';

const ListingRating = ({ rating, numberOfReviews, onClick }) => {
  const ratingWidthPercent = (rating * 100) / 5;
  return (
    <ListingRatingContainer onClick={onClick} data-reviews-button>
      <StarWrapper>
        <SkeletonStar icon={starEmptySvg} size="16px" />
        <FilledStarWrapper width={ratingWidthPercent}>
          <FilledStar icon={starSvg} size="16px" />
        </FilledStarWrapper>
      </StarWrapper>
      <RatingWrapper>
        {numberOfReviews}
      </RatingWrapper>
    </ListingRatingContainer>

  );
};

ListingRating.propTypes = {
  rating: PropTypes.number,
  numberOfReviews: PropTypes.number,
  onClick: PropTypes.func,
};

ListingRating.defaultProps = {
  rating: 0,
  numberOfReviews: 0,
  onClick: () => { },
};

export default ListingRating;
